import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';

import Error404 from '../containers/Error404';
import ServicesDash from "../containers/services/ServicesDash";
import Tickets from "../containers/services/Tickets";
import Delivery from "../containers/settings/Delivery";

class ServicesRoute extends Component {

    render() {
        return (
            <div>
                {this.props.children}
                <Switch>
                    <Route exact path='/services' component={ServicesDash}/>
                    <Route exact path='/services/tickets' component={Tickets}/>
                    <Route exact path='/services/delivery' component={Delivery} />
                    <Route exact path={'*'} component={Error404}/>
                </Switch>
            </div>
        );
    }
}

export default ServicesRoute;



// WEBPACK FOOTER //
// ./src/routes/ServicesRoute.js